module.exports = "* {\n  color: #f87c08; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/about/about.component.scss
// module id = 388
// module chunks = 1